import { Config } from './types';

// eslint-disable-next-line
const config = require(`./${process.env.NEXT_PUBLIC_VERCEL_ENV || 'development'}`)
  .default as Config;

export default config;
